import { Component } from "react";

import HeaderRouteName from "../components/HeaderRouteName";

export default class ExtensionReport extends Component {
  render() {
    return (
      <div className="border-bottom white-bg dashboard-header">
        <HeaderRouteName nestedRouteNames={["Reports", "Extension"]} />
      </div>
    );
  }
}
